import { CFIconLogIn } from './log-in';
import { CFIconLogOut } from './log-out';
import { CFIconPeople } from './people';
import { CFIconPerson } from './person';
import { CFIconPersonAdd } from './person-add';
import { CFIconPersonDelete } from './person-delete';
import { CFIconPersonDone } from './person-done';
import { CFIconPersonRemove } from './person-remove';
export const CFIconGroupAccount = [
    CFIconLogIn,
    CFIconLogOut,
    CFIconPeople,
    CFIconPerson,
    CFIconPersonAdd,
    CFIconPersonDelete,
    CFIconPersonDone,
    CFIconPersonRemove,
];
